import dayjs from "dayjs";
import React from "react";
import { GoHeart } from "react-icons/go";

type Props = { data: any };

const InfoSalon = ({ data }: Props) => {
  console.log(data);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-6">
      <div className="flex flex-col items-center justify-center w-full gap-1">
        <h3 className="text-color-primary font-semibold text-xl">
          {data?.name}
        </h3>
        <span className="text-[#75757E] text-sm font-medium">
          Joined {dayjs(data?.created_at).format("MMM. YYYY")}
        </span>
        <div className="flex mt-2 items-center text-[#9999A7] text-sm font-medium gap-1">
          <span>location:</span>
          <span className="max-w-[300px] flex flex-wrap">
            {data?.business_location?.Address
              ? data?.business_location?.Address
              : `${data?.business_location?.City || ""} ${
                  data?.business_location?.District || ""
                } ${data?.business_location?.streetName || ""} ${
                  data?.business_location?.Building || ""
                }`}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <GoHeart className="text-black flex items-center" />
          <span className="text-[#9999A7] text-sm font-normal truncate max-w-[10rem]">
            {data?.service_categories?.map((e: any, index: number) => (
              <React.Fragment key={index}>
                <span className="mx-1">{e?.name}</span>
                {index < data?.service_categories?.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <GoHeart className="text-[#A62727] flex items-center" />
          <span className="text-[#9999A7] text-sm font-normal">
            {data?.reviews?.reviewers} Reviews
          </span>
        </div>
      </div>
      <div className="flex items-center gap-11">
        <div className="flex items-center flex-col gap-1 justify-between">
          <span className="text-color-primary text-2xl font-bold">
            {data?.appointments_count}
          </span>
          <span className="text-[#9999A7] text-sm font-normal">
            Appointments
          </span>
        </div>
        <div className="flex items-center flex-col gap-1 justify-between">
          <span className="text-color-primary text-2xl font-bold">
            {data?.team_members?.length}
          </span>
          <span className="text-[#9999A7] text-sm font-normal">Staff</span>
        </div>
        <div className="flex items-center flex-col gap-1 justify-between">
          <span className="text-color-primary text-2xl font-bold">
            {data?.appointments_sum_cost || 0}$
          </span>
          <span className="text-[#9999A7] text-sm font-normal">Revenue</span>
        </div>
      </div>
    </div>
  );
};

export default InfoSalon;
